module.exports = __webpack_public_path__ + "static/media/bd-speakers-text-only.30054506.png";